import { KioskStateType } from "../../KioskReducer"
import { ActionType } from "../../Actions"
import { SETTINGS_OPENED_TOGGLE } from "../../Actions/Kiosk/settingsOpenedToggleAction";

export default function fontSizeReducer(
  state: KioskStateType,
  action: ActionType
): KioskStateType {
  switch(action.type) {
    case SETTINGS_OPENED_TOGGLE:
      return {
          ...state,
          settingsOpened: action.payload.settingsOpened
      }
  }

  return state;
}
